export const normalizeInvestorPerks = (value) => {
    if(typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            if(Array.isArray(parsed) || typeof parsed === "string") {
                return normalizeInvestorPerks(parsed);
            }
        } catch{
            return value.trim()
                ? [{ amount: "", description: value }]
                : [{ amount: "", description: "" }];
        }
    }

    if(Array.isArray(value)) {
        const perks = value.slice(0, 5).map((perk) => {
            if(typeof perk === "string") {
                return { amount: "", description: perk };
            }

            return {
                amount: perk?.amount != null ? String(perk.amount) : "",
                description:
                    perk?.description != null ? String(perk.description) : "",
            };
        });

        return perks.length ? perks : [{ amount: "", description: "" }];
    }

    return [{ amount: "", description: "" }];
};

export const formatInvestorPerkAmount = (value) => {
    const amount = String(value ?? "")
        .trim()
        .replace(/^\$+\s*/, "");

    return amount ? `$${amount}` : "";
};
